define('app/main',['require','jquery','./views/busca','./views/produtos'],function (require) {
    
   require('jquery');
   
   $(function(){
       

        var BuscaView = require('./views/busca');
        var ProdutosView = require('./views/produtos');
        


        var buscaView = new BuscaView({
            el:'#formBusca'
        });
        
        var produtosView = new ProdutosView({
            el: '.resultado-busca-produtos'
        });
   });


});

